<!--
 * @Date: 2023-12-22 11:25:21
 * @LastEditTime: 2024-04-30 10:55:42
-->
<template>
  <el-popover ref="refpopover" placement="top-start" width="260" trigger="hover">
    <div class="userinfo-top">
      <el-avatar :size="60" shape="square" :src="avatar || './base/images/layout/user.png'" :alt="baseinfo.name || ''"
        fit="contain" class="popoveravatar" />
      <div class="userinfo-right">
        <h4>{{baseinfo.name}} {{baseinfo.zj}}</h4>
        <span>上海智隆信息技术股份有限公司</span>
        <span>部门：{{baseinfo.orgName}}</span>
      </div>
    </div>
    <ul class="userinfo-bottom">
      <!-- <li><span>邮箱：</span></li> -->
      <!-- <li><span>办公地点：</span></li> -->
      <!-- <li><span>职位：{{baseinfo.}}</span></li> -->
      <li><span>直属主管：</span>{{baseinfo.zsld}}</li>
      <li><span>手机号：</span>{{baseinfo.mobile}}</li>
      <li @click="goToda"><span>个人档案：</span><b class="gotoda">查看档案</b></li>
    </ul>
  </el-popover>
</template>
<script>
export default {
  props: {
    avatar: {
      type: String,
      default: () => { }
    },
    baseinfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      // baseinfo: {}
    }
  },
  methods: {
    goToda() {
      const data = {
        ...this.baseinfo,
        type: true
      }
      this.$emit('goToda', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.userinfo-top {
  display: flex;
  .userinfo-right {
    display: flex;
    margin-left: 10px;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    h4 {
      margin: 0;
      color: #000;
    }
    span {
      font-size: 12px;
    }
  }
}
.userinfo-bottom {
  padding: 10px 0 0 0;
  li {
    list-style: none;
    line-height: 2;
    font-size: 12px;
    color: #000;
    span {
      width: 80px;
      display: inline-block;
      color: #999;
    }
    .gotoda {
      color: #409eff;
      font-weight: normal;
      cursor: pointer;
    }
  }
}
.useravatar {
  width: 60px;
  height: 60px;
  img {
    width: 100%;
    border-radius: 50%;
    object-fit: fill;
  }
}
</style>
